export default function (mortgage, config) {

    const accountDetails = JSON.parse(mortgage.requirement.ddBankAccountDetails || '{}')

    const address = (accountDetails.address || '').split('\n')
    const part1 = () => {
        let obj = {}
        let map = {}
        let ask = []
        let errors = []


        // Mortgage Number
        ask.push({
            label: 'Mortgage Reference',
            name: 'mortgageReference',
            type: 'TEXT',
            group: 'Part 1'
        })
        let digits = mortgage.activeSubmission?.mortgageAccountNo
        if (config.hasOwnProperty('mortgageReference')) {
            digits = config.mortgageReference
        }
        if (digits && digits.length > 0) {
            obj['Your Mortgage reference/account number'] = {string: digits.toUpperCase()}
        } else {
            errors.push('No mortgage loan account number')
        }


        // Customer Name
        ask.push({
            label: 'Customer Name',
            name: 'customerName',
            type: 'TEXT',
            group: 'Part 1'
        })
        let name = config.customerName ?? accountDetails.name
        if (!name) {
            errors.push('No debtor name')
        } else {
            obj['*Customer Name(s)'] = {string: name.toUpperCase()}
        }

        // Address
        ask.push({
            label: 'Address',
            name: 'address',
            type: 'TEXT',
            group: 'Part 1'
        })

        let address = config.address || accountDetails.address
        if (!address) {
            errors.push('No address provided')
        } else {
            obj['Customer Address'] = {string: address} // Address Line 1
        }


        //EIRCODE
        ask.push({
            label: 'Eircode',
            name: 'eircode',
            type: 'TEXT',
            group: 'Part 1'
        })
        let eircode = (config.eircode || accountDetails.postCode)
        if (eircode) {
            obj['*Eircode'] = {string: eircode.toUpperCase()} // Eircode
        } else {
            errors.push('No Eircode provided')
        }

        // Country
        ask.push({
            label: 'Country',
            name: 'country',
            type: 'TEXT',
            group: 'Part 1'
        })
        let country = (config.country || accountDetails.country || 'Ireland')

        obj['*Country'] = {string: country.toUpperCase()}


        ask.push({
            label: 'IBAN',
            name: 'iban',
            type: 'TEXT',
            group: 'Part 1'
        })
        let iban = config.iban || accountDetails.iban || ''
        let characters = iban.replace(/[^a-z0-9]/gi, '').toUpperCase().split('')
        // IBAN
        const firstPart = iban.replace(/[^a-z0-9]/gi, '').toUpperCase().slice(0, 22);
        const secondPart = iban.replace(/[^a-z0-9]/gi, '').toUpperCase().slice(22);
        obj['*IBAN'] = {string: firstPart}
        obj['*IBAN 2'] = {string: secondPart}

        // obj['Text Field 769'] = {string: characters[0] || ''}
        // obj['Text Field 86'] = {string: characters[1] || ''}
        // obj['Text Field 87'] = {string: characters[2] || ''}
        // obj['Text Field 88'] = {string: characters[3] || ''}
        // obj['Text Field 92'] = {string: characters[4] || ''}
        // obj['Text Field 93'] = {string: characters[5] || ''}
        // obj['Text Field 94'] = {string: characters[6] || ''}
        // obj['Text Field 95'] = {string: characters[7] || ''}
        // obj['Text Field 96'] = {string: characters[8] || ''}
        // obj['Text Field 97'] = {string: characters[9] || ''}
        // obj['Text Field 98'] = {string: characters[10] || ''}
        // obj['Text Field 99'] = {string: characters[11] || ''}
        // obj['Text Field 100'] = {string: characters[12] || ''}
        // obj['Text Field 101'] = {string: characters[13] || ''}
        // obj['Text Field 102'] = {string: characters[14] || ''}
        // obj['Text Field 103'] = {string: characters[15] || ''}
        // obj['Text Field 104'] = {string: characters[16] || ''}
        // obj['Text Field 105'] = {string: characters[17] || ''}
        // obj['Text Field 106'] = {string: characters[18] || ''}
        // obj['Text Field 107'] = {string: characters[19] || ''}
        // obj['Text Field 108'] = {string: characters[20] || ''}
        // obj['Text Field 109'] = {string: characters[21] || ''}
        // obj['Text Field 89'] =  {string: characters[22] || ''}
        // obj['Text Field 90'] = {string: characters[23] || ''}
        // obj['Text Field 91'] = {string: characters[24] || ''}
        // obj['Text Field 110'] ={string: characters[25] || ''}
        // obj['Text Field 111'] ={string: characters[26] || ''}
        // obj['Text Field 112'] ={string: characters[27] || ''}
        // obj['Text Field 113'] ={string: characters[28] || ''}
        // obj['Text Field 114'] ={string: characters[29] || ''}
        // obj['Text Field 115'] ={string: characters[30] || ''}
        // obj['Text Field 116'] ={string: characters[31] || ''}
        // obj['Text Field 117'] = {string: characters[32] || ''}
        // obj['Text Field 118'] = {string: characters[33] || ''}


        // BIC
        ask.push({
            label: 'BIC',
            name: 'bic',
            type: 'TEXT',
            group: 'Part 1'
        })
        let bic = config.bic || accountDetails.bic || ''
        obj['*BIC'] = {string: bic.replace(/[^a-z0-9]/gi, '').toUpperCase()}
        //let charactersB = bic.replace(/[^a-z0-9]/gi, '').toUpperCase().split('')
        // obj['Text Field 119'] =  {string: charactersB[0] || ''}
        // obj['Text Field 120'] = {string: charactersB[1] || ''}
        // obj['Text Field 121'] = {string: charactersB[2] || ''}
        // obj['Text Field 122'] = {string: charactersB[3] || ''}
        // obj['Text Field 123'] = {string: charactersB[4] || ''}
        // obj['Text Field 124'] = {string: charactersB[5] || ''}
        // obj['Text Field 125'] = {string: charactersB[6] || ''}
        // obj['Text Field 126'] = {string: charactersB[7] || ''}
        // obj['Text Field 127'] = {string: charactersB[8] || ''}
        // obj['Text Field 128'] = {string: charactersB[9] || ''}
        // obj['Text Field 129'] = {string: charactersB[10] || ''}

        return {map: obj, ask, errors}
    }

    return {sections: [part1()]}
}